import GreenCheckIcon from "@/common/svgs/green-check";

type Props = {
	description: string;
	monthlyEntries: number;
	weeklyEntries: number;
	isSelected: boolean;
};

export default function PlanFeatures({
	description,
	monthlyEntries,
	weeklyEntries,
	isSelected,
}: Props) {
	const featureClassName = isSelected
		? "web-body-b1 text-wrap text-white-80"
		: "web-body-b1 text-wrap text-gray-700";

	return (
		<div className="flex flex-col gap-4">
			<div className="flex flex-row gap-3">
				<GreenCheckIcon />
				<p className={featureClassName}>{description}</p>
			</div>
			<div className="flex flex-row gap-3">
				<GreenCheckIcon />
				<p className={featureClassName}>
					{`${monthlyEntries} x accumulating entry for monthly giveaways`}
				</p>
			</div>
			<div className="flex flex-row gap-3">
				<GreenCheckIcon />
				<span className={featureClassName}>
					{`${weeklyEntries} x entries for weekly `}
					<span className="underline">member-only</span> <span>giveaways</span>
				</span>
			</div>
		</div>
	);
}
